/* eslint-disable sonarjs/no-duplicate-string */

export const cfbGateways = [
  { dev: 'https://d-cfb.dev.digitaledge.cigna.com/v1/cfb' },
  { devService: 'https://d-cfb.dev.digitaledge.cigna.com/service' },
  { devCfbSecure: 'https://d-cfb.dev.digitaledge.cigna.com/v1/secure' },
  { int: 'https://d-cfb.dev.digitaledge.cigna.com/v1/cfb' },
  { intService: 'https://d-cfb.dev.digitaledge.cigna.com/service' },
  { intCfbSecure: 'https://d-cfb.dev.digitaledge.cigna.com/v1/secure' },
  { sit: 'https://d-cfb.dev.digitaledge.cigna.com/v1/cfb' },
  { sitService: 'https://d-cfb.dev.digitaledge.cigna.com/service' },
  { sitCfbSecure: 'https://d-cfb.dev.digitaledge.cigna.com/v1/secure' },
  { rel: 'https://a-cfb.test.digitaledge.cigna.com/v1/cfb' },
  { relService: 'https://a-cfb.test.digitaledge.cigna.com/service' },
  { relCfbSecure: 'https://a-cfb.test.digitaledge.cigna.com/v1/secure' },
  { pvs: 'https://v-cfb.test.digitaledge.cigna.com/v1/cfb' },
  { pvsService: 'https://v-cfb.test.digitaledge.cigna.com/service' },
  { pvsCfbSecure: 'https://v-cfb.test.digitaledge.cigna.com/v1/secure' },
  { pfix: 'https://p-cfb.digitaledge.cigna.com/v1/cfb' },
  { pfixService: 'https://p-cfb.digitaledge.cigna.com/service' },
  { pfixCfbSecure: 'https://p-cfb.digitaledge.cigna.com/v1/secure' },
  { prod: 'https://p-cfb.digitaledge.cigna.com/v1/cfb' },
  { prodService: 'https://p-cfb.digitaledge.cigna.com/service' },
  { prodCfbSecure: 'https://p-cfb.digitaledge.cigna.com/v1/secure' },
  { ifpadminint: 'https://d-cfb.dev.digitaledge.cigna.com/v1/cfb' },
  { ifpadminintService: 'https://d-cfb.dev.digitaledge.cigna.com/service' },
  { ifpadminintCfbSecure: 'https://d-cfb.dev.digitaledge.cigna.com/v1/secure' },
  { ifpadminrel: 'https://a-cfb.test.digitaledge.cigna.com/v1/cfb' },
  { ifpadminrelService: 'https://a-cfb.test.digitaledge.cigna.com/service' },
  {
    ifpadminrelCfbSecure: 'https://a-cfb.test.digitaledge.cigna.com/v1/secure',
  },
  { ifpadminprod: 'https://p-cfb.digitaledge.cigna.com/v1/cfb' },
  { ifpadminprodService: 'https://p-cfb.digitaledge.cigna.com/service' },
  { ifpadminprodCfbSecure: 'https://p-cfb.digitaledge.cigna.com/v1/secure' },
  { agentviewint: 'https://d-cfb.dev.digitaledge.cigna.com/v1/cfb' },
  { agentviewintService: 'https://d-cfb.dev.digitaledge.cigna.com/service' },
  { agenviewCfbSecure: 'https://d-cfb.dev.digitaledge.cigna.com/v1/secure' },
  { agentviewrel: 'https://a-cfb.test.digitaledge.cigna.com/v1/cfb' },
  { agentviewrelService: 'https://a-cfb.test.digitaledge.cigna.com/service' },
  {
    agentviewrelCfbSecure: 'https://a-cfb.test.digitaledge.cigna.com/v1/secure',
  },
  { agentviewpvs: 'https://v-cfb.test.digitaledge.cigna.com/v1/cfb' },
  { agentviewpvsService: 'https://v-cfb.test.digitaledge.cigna.com/service' },
  {
    agentviewpvsCfbSecure: 'https://v-cfb.test.digitaledge.cigna.com/v1/secure',
  },
  { agentviewprod: 'https://p-cfb.digitaledge.cigna.com/v1/cfb' },
  { agentviewprodService: 'https://p-cfb.digitaledge.cigna.com/service' },
  { agentviewprodCfbSecure: 'https://p-cfb.digitaledge.cigna.com/v1/secure' },
];
